<template>
<div>
  <h1>your Dashboard</h1>
  <div>
    <div>
      <h5>All questions {{getCategoryIntersect(all)}}/{{all.length}} </h5>
      <skillbar :progress='getCategoryIntersectPercent(all)'></skillbar>
      <button v-if="all.length != getCategoryIntersect(all)" class="x-btn x-btn-small" @click="startTestAll(true)">continue</button>
      <button v-if="all.length == getCategoryIntersect(all)" class="x-btn x-btn-small" @click="startTestAll(false)">test</button>
    </div>
  </div>
  <div class="clearfix"></div>

    <div>
      <div v-for="category in categories" class="progressbar">
        <h5>{{category.name}} {{getCategoryIntersect(category.questions)}}/{{category.questions.length}} </h5>
        <skillbar :progress="getCategoryIntersectPercent(category.questions, category.questions.length)"></skillbar>
        <button v-if="category.questions.length != getCategoryIntersect(category.questions)" class="x-btn x-btn-small" @click="startTest(category, true)">continue</button>
        <button v-if="category.questions.length == getCategoryIntersect(category.questions)" class="x-btn x-btn-small" @click="startTest(category, false)">test</button>
      </div>
    </div>
</div>
</template>

<script>

import skillbar from './Helpers/skillbar.vue'
import _ from 'underscore'

export default {
  name: 'journey',
  components:{
    skillbar
  },
  mounted : function(){
    var vm = this;

    vm.$http.get('https://biolympiads.com/wp-json/bioquiz/v1/getJourney').then(response => {

        vm.categories = response.data.categories;
        vm.all = response.data.all;
        vm.correctlyAnswered = response.data.correctlyAnswered;
        vm.incorrectlyAnswered = response.data.incorrectlyAnswered;

      }, response => {
        console.error(response);
      });
  },
  data () {
    return {
      categories: [],
      all: [],
      correctlyAnswered: [],
      incorrectlyAnswered: []
    }
  },
  watch:{

  },
  methods: {
    getCategoryIntersectPercent: function(cat){
      var vm = this;
      return parseInt(_.intersection(cat, vm.correctlyAnswered).length *100 / cat.length);
    },
    getCategoryIntersect: function(cat){
      var vm = this;
      return _.intersection(cat, vm.correctlyAnswered).length;
    },
    startTest(cat, getUnansweredQuestions){
      var vm = this;
      var selected = {};
      selected.topics = [cat.slug]
      selected.getUnansweredQuestions = getUnansweredQuestions;
      vm.$emit('start', selected);
    },
    startTestAll(getUnansweredQuestions){
      var vm = this;
      var selected = {};
      selected.topics = []
      selected.getUnansweredQuestions = getUnansweredQuestions;
      vm.$emit('start', selected);
    },    
    toggeYear: function(year){
      var vm = this;
      if(!vm.selected.years.includes(year)){
        vm.selected.years.push(year);
      } else {
        let index = vm.selected.years.indexOf(year);
        vm.selected.years.splice(index, 1);
      }
      console.log('amainzg', year);
    },
    toggeCompetition: function(competition){
      var vm = this;
      if(!vm.selected.competitions.includes(competition)){
        vm.selected.competitions.push(competition);
      } else {
        let index = vm.selected.competitions.indexOf(competition);
        vm.selected.competitions.splice(index, 1);
      }
      console.log('amainzg', competition);
    },
    toggeTopics: function(topic){
      var vm = this;
      if(!vm.selected.topics.includes(topic)){
        vm.selected.topics.push(topic);
      } else {
        let index = vm.selected.topics.indexOf(topic);
        vm.selected.topics.splice(index, 1);
      }
      console.log('amainzg', topic);
    },
    start: function(){
      var vm = this;
      vm.$emit('start', vm.selected);
    }
  },
  watch: {
    selectedMode: function(item){
      console.log(item);
      console.log('pasikeite');
      var vm = this;
      vm.selected = {
        years:[],
        competitions: [],
        topics: [],
      };

    }
  }
}
</script>

<style lang="scss">

/*.selector {
  width: 300px;
  float: left;
}*/
.progressbar{
  width: 48%;
  float: left;
  margin-left: 1%;
}
.active{
  background: green;
  color:white;
}



.checkbox-wrapper input.input-checkbox {
    display: none
}

.checkbox-wrapper input.input-checkbox:checked+.checkbox {
    background-color: #67b600;
    border-color: #67b600
}

.checkbox-wrapper input.input-checkbox:checked+.checkbox:after {
    border-left: 1px solid #fff;
    border-bottom: 1px solid #fff;
    width: 13px;
    height: 7px;
    -webkit-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    transform: rotate(-45deg);
    position: absolute;
    left: 3px;
    top: 2px;
    display: block;
    content: '';
}
.checkbox-wrapper .checkbox {
    display: inline-block;
    width: 15px;
    height: 15px;
    border: 1px solid #dedede;
    border-radius: 2px;
    background-color: #fff;
    position: relative;
    margin: 0 8px 0 0;
}
ul {
  list-style: none;
}

.checkbox-label {
  cursor: pointer;
}

.pull-right{
  float:right;
}
</style>



// WEBPACK FOOTER //
// Journey.vue?c946daa6